<template>
  <page-template type="norightpanel">
    <template v-slot:toolbar>
        <tool-bar type="accounts" title="Gestion des comptes" linkplusicon="/comptes/new" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <data-table
        text1="Administrateur(s) : "
        number1="1"
        text2="Family Office(s) : "
        number2="12"
        text3="Régie(s) : "
        number3="5"
        :headers="headers"
        :items="accounts"
      ></data-table>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import dataTable from '@/components/DataTable.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Comptes',
    components: { pageTemplate, toolBar, dataTable },
    data: () => {
      return {
        headers: [
          { text: 'Société', value: 'society' },
          { text: 'Nom', value: 'nameaccount' },
          { text: 'Prénom', value: 'surname' },
          { text: 'Email', value: 'email' },
          { text: 'Rôle', value: 'role' }
        ],
        accounts: [
          {
            society: 'Orpi',
            nameaccount: 'Dupont',
            surname: 'Jean',
            email: 'jeandupont@mail.fr',
            role: 'Régie'
          },
          {
            society: 'Orpi',
            nameaccount: 'Dupont',
            surname: 'Jean',
            email: 'jeandupont@mail.fr',
            role: 'Régie'
          },
          {
            society: 'Orpi',
            nameaccount: 'Dupont',
            surname: 'Jean',
            email: 'jeandupont@mail.fr',
            role: 'Régie'
          },
          {
            society: 'Orpi',
            nameaccount: 'Dupont',
            surname: 'Jean',
            email: 'jeandupont@mail.fr',
            role: 'Régie'
          }
        ]
      }
    },
    async created () {
      try {
        // ALL ADMIN USERS
        const adminUsersRes = await axios.get(`${apiURL}/data/admins`)
        this.adminUser = adminUsersRes.data
        // ADMIN USER DETAIL
        const adminUserDetailRes = await axios.get(`${apiURL}/data/admin/:id`)
        this.adminUserDetail = adminUserDetailRes.data
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>